import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import Styled from './style';
import logo from '../../../../assets/images/black-logo-text.png';
import { Typography } from '../../../../shared/typography';

type IProps = {
	user: any;
	toggleModal(): void;
};

const Header: FC<IProps> = ({ user, toggleModal }) => {
	return (
		<Styled.Header>
			<Styled.LeftContent>
				<Styled.Logo src={logo} alt="logo" />
			</Styled.LeftContent>
			<Styled.MiddleContent>
				<Link to="/">
					<Typography
						text={'Create any CRM report with Revvy in 5 seconds 🚀 '}
					/>
				</Link>
			</Styled.MiddleContent>
			<Styled.RightContent>
				{!user._id ? (
					<Styled.Button onClick={toggleModal}>
						<Typography
							text={'Sign up'}
							type="bold"
							size="large"
							color="white"
						/>
					</Styled.Button>
				) : null}
			</Styled.RightContent>
		</Styled.Header>
	);
};

export default Header;
